import { DiaHabil, GuiaDespacho } from '../types/inventario'
import { Tono } from '../components/kit'

/*
  Teletrabajo (core/teletrabajo.py): el bien sale el día hábil anterior a un tramo de
  teletrabajo y vuelve el siguiente; días seguidos son un solo viaje y el fin de semana
  no corta. El servidor calcula las guías; aquí solo se explica el patrón de la semana.
*/

export const DIAS: { dia: DiaHabil; texto: string; corto: string }[] = [
  { dia: 0, texto: 'lunes', corto: 'Lun' },
  { dia: 1, texto: 'martes', corto: 'Mar' },
  { dia: 2, texto: 'miércoles', corto: 'Mié' },
  { dia: 3, texto: 'jueves', corto: 'Jue' },
  { dia: 4, texto: 'viernes', corto: 'Vie' },
]

export const SENTIDO: Record<GuiaDespacho['sentido'], { texto: string; tono: Tono }> = {
  SALIDA: { texto: 'Salida', tono: 'aviso' },
  ENTRADA: { texto: 'Entrada', tono: 'exito' },
}

const lista = (xs: string[]) => (xs.length === 1 ? xs[0] : `${xs.slice(0, -1).join(', ')} y ${xs[xs.length - 1]}`)

/** [1, 3] -> 'martes y jueves'. */
export const nombrarDias = (dias: DiaHabil[]) => lista([...dias].sort().map((d) => DIAS[d].texto))

/**
 * Los viajes de una semana tipo: 'martes: sale el lunes y vuelve el miércoles'. Lunes
 * sale el viernes anterior; viernes vuelve el lunes siguiente.
 */
export function viajes(dias: DiaHabil[]): string[] {
  const hay = new Set(dias)
  if (!hay.size || hay.size === 5) return []
  const antes = (d: number) => (d + 4) % 5
  const despues = (d: number) => (d + 1) % 5
  const salida = (d: number) => (d === 0 ? 'el viernes anterior' : `el ${DIAS[antes(d)].texto}`)
  const vuelta = (d: number) => (d === 4 ? 'el lunes siguiente' : `el ${DIAS[despues(d)].texto}`)
  const resultado: string[] = []
  for (const inicio of DIAS.map((d) => d.dia).filter((d) => hay.has(d) && !hay.has(antes(d) as DiaHabil))) {
    const tramo = [inicio as number]
    while (hay.has(despues(tramo[tramo.length - 1]) as DiaHabil)) tramo.push(despues(tramo[tramo.length - 1]))
    const fin = tramo[tramo.length - 1]
    resultado.push(`${lista(tramo.map((d) => DIAS[d].texto))}: sale ${salida(inicio)} y vuelve ${vuelta(fin)}`)
  }
  return resultado
}
